module.exports = __webpack_public_path__ + "img/video.594942f8.png";